import { defineMessages } from 'react-intl';

export default defineMessages({
    activities: {
        id: 'e1p.gateway.views.cancellation-detail.Activities',
        defaultMessage: 'Activities'
    },
    sureBindCancellation: {
        id: 'e1p.gateway.views.cancellation-detail.Are you sure you want to bind this cancellation?',
        defaultMessage: 'Are you sure you want to bind this cancellation?'
    },
    bind: {
        id: 'e1p.gateway.views.cancellation-detail.Bind',
        defaultMessage: 'Bind'
    },
    bindingCancellation: {
        id: 'e1p.gateway.views.cancellation-detail.Binding Cancellation',
        defaultMessage: 'Binding Cancellation'
    },
    cancellation: {
        id: 'e1p.gateway.directives.cancel-policy.Cancel Policy',
        defaultMessage: 'Cancel Policy'
    },
    description: {
        id: 'e1p.gateway.views.cancellation-detail.Description',
        defaultMessage: 'Description'
    },
    cancellaionDescription: {
        id: 'e1p.gateway.views.cancellation-detail.Reason Description',
        defaultMessage: 'Reason Description'
    },
    cancellationEffectiveDate: {
        id: 'e1p.gateway.views.cancellation-detail.Cancellation Effective Date',
        defaultMessage: 'Cancellation Effective Date'
    },
    cancellationCreateDate: {
        id: 'e1p.gateway.views.cancellation-detail.Cancellation Create Date',
        defaultMessage: 'Cancellation Create Date'
    },
    effectiveDate: {
        id: 'e1p.gateway.views.cancellation-detail.Effective Date',
        defaultMessage: 'Effective Date'
    },
    cancellationSource: {
        id: 'e1p.gateway.views.cancellation-detail.Source',
        defaultMessage: 'Source'
    },
    taxesAndSurcharges: {
        id: 'e1p.gateway.views.cancellation-detail.Taxes & Surcharges',
        defaultMessage: 'Taxes & Surcharges'
    },
    insuredResidenceAddress: {
        id: 'e1p.gateway.views.cancellation-detail.Insured Residence Address',
        defaultMessage: 'Insured Residence Address'
    },
    failedToBindCancellation: {
        id: 'e1p.gateway.views.cancellation-detail.Failed to bind cancellation',
        defaultMessage: 'Failed to bind cancellation'
    },
    failedToWithdrawCancellation: {
        id: 'e1p.gateway.views.cancellation-detail.Failed to withdraw cancellation',
        defaultMessage: 'Failed to withdraw cancellation'
    },
    needToCancelStartNewCancellation: {
        id: 'e1p.gateway.views.cancellation-detail.If you need to cancel the policy please create a new Cancellation',
        defaultMessage: 'If you need to cancel the policy, please start a new cancellation.'
    },
    needReinitiateContactUnderWriter: {
        id: 'e1p.gateway.views.cancellation-detail.If you need to reinstate this policy please contact the underwriter',
        defaultMessage: 'If you need to reinstate this policy, please contact the underwriter.'
    },
    noNotesAssociatedWithCancellation: {
        id: 'e1p.gateway.views.cancellation-detail.There are no notes associated with this cancellation.',
        defaultMessage: 'There are no notes associated with this cancellation.'
    },
    note: {
        id: 'e1p.gateway.views.cancellation-detail.Note',
        defaultMessage: 'Note'
    },
    notes: {
        id: 'e1p.gateway.views.cancellation-detail.Notes',
        defaultMessage: 'Notes'
    },
    openActivities: {
        id: 'e1p.gateway.views.cancellation-detail.Open Activities',
        defaultMessage: 'Open Activities'
    },
    OpenIssues: {
        id: 'e1p.gateway.views.cancellation-detail.OpenIssues',
        defaultMessage: 'Open UW Issues'
    },
    premium: {
        id: 'e1p.gateway.views.cancellation-detail.Policy Premium',
        defaultMessage: 'Policy Premium'
    },
    reason: {
        id: 'e1p.gateway.views.cancellation-detail.Cancellation Reason',
        defaultMessage: 'Cancellation Reason'
    },
    refundAmount: {
        id: 'e1p.gateway.views.cancellation-detail.Cancel Credit',
        defaultMessage: 'Cancel Credit'
    },
    cancelMethod: {
        id: 'e1p.gateway.views.cancellation-detail.Cancel Method',
        defaultMessage: 'Cancel Method'
    },
    status: {
        id: 'e1p.gateway.views.cancellation-documents.Status',
        defaultMessage: 'Status'
    },
    stillOwed: {
        id: 'e1p.gateway.views.cancellation-detail.Still Owed',
        defaultMessage: 'Still Owed'
    },
    summary: {
        id: 'e1p.gateway.views.cancellation-detail.Summary',
        defaultMessage: 'Summary'
    },
    cancellationAmountToBeCalculated: {
        id: 'e1p.gateway.views.cancellation-detail.The cancellation refund amount has been calculated.',
        defaultMessage: 'The cancellation refund amount has been calculated.'
    },
    cancellationHasBeenWithBound: {
        id: 'e1p.gateway.views.cancellation-detail.This cancellation has been bound.',
        defaultMessage: 'This cancellation has been bound.'
    },
    cancellationHasBeenWithDrawn: {
        id: 'e1p.gateway.views.cancellation-detail.This cancellation has been withdrawn.',
        defaultMessage: 'This cancellation has been withdrawn.'
    },
    cancellationOwnedByCarrier: {
        id: 'e1p.gateway.views.cancellation-detail.This cancellation is owned by the carrier',
        defaultMessage: 'This cancellation is owned by the carrier'
    },
    cancellationInitiatedByInsurer: {
        id: 'e1p.gateway.views.cancellation-detail.This cancellation was initiated by the insurer',
        defaultMessage: 'This cancellation was initiated by the insurer'
    },
    withdraw: {
        id: 'e1p.gateway.views.cancellation-detail.Withdraw',
        defaultMessage: 'Withdraw'
    },
    withdrawingCancellation: {
        id: 'e1p.gateway.views.cancellation-detail.Withdrawing Cancellation',
        defaultMessage: 'Withdrawing Cancellation'
    },
    cannotUndoOnceBound: {
        id: "e1p.gateway.views.cancellation-detail.You won't be able to undo once bound.",
        defaultMessage: "You won't be able to undo once bound."
    },
    withDrawActivitiesNotesDocument: {
        id: 'e1p.gateway.views.cancellation-detail.You can choose to Withdraw the Cancellation or add Activities, Notes, or Documents',
        defaultMessage: 'You can choose to Withdraw the Cancellation or add Activities, Notes, or Documents'
    },
    youCanViewInformationCannotBindOrWithdraw: {
        id: 'e1p.gateway.views.cancellation-detail.You can view information but cannot bind or withdraw',
        defaultMessage: 'You can view information but cannot bind or withdraw'
    },
    lastDays: {
        id: 'e1p.gateway.views.cancellation-detail.last 30 Days',
        defaultMessage: 'Issued in Last 30 Days'
    },
    openBound: {
        id: 'e1p.gateway.views.cancellation-detail.Open Bound',
        defaultMessage: 'Open - Bound'
    },
    openNotBound: {
        id: 'e1p.gateway.views.cancellation-detail.Open Not Bound',
        defaultMessage: 'Open - Not Bound'
    },
    errorLoadingDocuments: {
        id: 'e1p.gateway.views.cancellation-documents.Error loading documents',
        defaultMessage: 'Error loading documents.'
    },
    longDescription: {
        id: 'e1p.gateway.views.cancellation-documents.Long Description',
        defaultMessage: 'Long Description'
    },
    shortDescription: {
        id: 'e1p.gateway.views.cancellation-documents.Short Description',
        defaultMessage: 'Short Description'
    },
    underwritingIssuesAssociatedWithCancellation: {
        id: 'e1p.gateway.views.cancellation-documents.There are no open underwriting issues associated with this cancellation',
        defaultMessage: 'There are no open underwriting issues associated with this cancellation'
    },
    errorLoadingNotes: {
        id: 'e1p.gateway.views.cancellation-notes.Error loading notes.',
        defaultMessage: 'Error loading notes.'
    },
    stillOwedHasBeenCalculated: {
        id: 'e1p.gateway.views.cancellation-detail.The cancellation amount still owed has been calculated',
        defaultMessage: 'The cancellation amount still owed has been calculated'
    },
    bindActivitiesNotesDocument: {
        id: 'e1p.gateway.views.cancellation-detail.You can choose to Bind or Withdraw the Cancellation or add Activities, Notes, or Documents',
        defaultMessage: 'You can either bind or withdraw the cancellation.'
    },
    canNotBindOrWithDrawButCanAddInfo: {
        id: 'e1p.gateway.views.cancellation-detail.You cannot withdraw or bind the cancellation, but you can add activities, notes and documents to it.',
        defaultMessage: 'You cannot withdraw or bind the cancellation, but you can add activities, notes and documents to it.'
    },
    failedWithDrawCancellation: {
        id: 'e1p.gateway.directives.JobSummary.Failed to withdraw cancellation',
        defaultMessage: 'Failed to withdraw cancellation'
    },
    wontUndoOnceBound: {
        id: 'e1p.gateway.views.cancellation-detail.You wont be able to undo once bound.',
        defaultMessage: 'You won\'t be able to undo once bound.'
    },
    canBindCancelCannotWithdraw: {
        id: 'e1p.gateway.views.cancellation-detail.You can bind the cancellation, but you cannot withdraw it.',
        defaultMessage: 'You can bind the cancellation, but you cannot withdraw it.'
    },
    paidDueDate: {
        id: 'e1p.gateway.views.cancellation-detail.Paid Due Date',
        defaultMessage: 'Paid Due Date'
    },
    bindCancellation: {
        id: 'e1p.gateway.views.cancellation-detail.Bind Cancellation',
        defaultMessage: 'Bind Cancellation'
    },
    continueCancellation: {
        id: 'e1p.gateway.views.cancellation-detail.ContinueCancellation',
        defaultMessage: 'Continue Cancellation'
    },
    doNotBind: {
        id: 'e1p.gateway.views.cancellation-detail.Do Not Bind',
        defaultMessage: 'Do Not Bind'
    },
    withdrawCancellation: {
        id: 'e1p.gateway.views.cancellation-detail.Withdraw Cancellation',
        defaultMessage: 'Withdraw Cancellation'
    },
    wantWithdrawCancellation: {
        id: 'e1p.gateway.views.cancellation-detail.Are you sure you want to withdraw the cancellation?',
        defaultMessage: 'Are you sure you want to withdraw the cancellation?'
    },
    doNotWithdraw: {
        id: 'e1p.gateway.views.cancellation-detail.Do Not Withdraw',
        defaultMessage: 'Do Not Withdraw'
    },
    needRescindCancellation: {
        id: 'e1p.gateway.views.cancellation-detail.needRescindCancellation',
        defaultMessage: 'If you need to rescind this policy, please click continue cancellation for more options.'
    },
    policyScheduledCancellation: {
        id: 'e1p.gateway.views.cancellation-detail.policyScheduledCancellation',
        defaultMessage: 'This policy is Scheduled for Cancellation'
    },
    preemptionInfoMessage: {
        id: 'e1p.gateway.views.cancellation-detail.This cancellation is no longer available due to another bound transaction. If needed, create a new cancellation transaction.',
        defaultMessage: 'This cancellation is no longer available due to another bound transaction. If needed, create a new cancellation transaction.' 
    }
});
